import {
  takeLatest, put, call, all,
} from 'redux-saga/effects';
import OrganizationService from '@services/organizations';
import { fetchOrganization, fetchOrganizationTitle, updateOrganization } from '@actions';
import { Organization, OrganizationDto } from '@rootCommon/types/organization';

import { AxiosError } from 'axios';
import { SagaGenerator } from './index';

// fetch item
function* fetchOrganizationAsync() {
  try {
    const organization: Organization = yield call(OrganizationService.getItem);

    yield put(fetchOrganization.success(organization));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(fetchOrganization.failure(error));
  }
}

function* watchFetchOrganization() {
  yield takeLatest(fetchOrganization.request, fetchOrganizationAsync);
}

// update
function* updateOrganizationAsync(action: { payload: OrganizationDto }) {
  try {
    const organization: Organization = yield call(OrganizationService.updateItem, action.payload);

    yield put(updateOrganization.success(organization));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(updateOrganization.failure(error));
  }
}

function* watchUpdateOrganization() {
  yield takeLatest(updateOrganization.request, updateOrganizationAsync);
}

// fetch title
function* fetchOrganizationTitleAsync() {
  try {
    const organization: Pick<Organization, 'title'> = yield call(OrganizationService.getTitle);

    yield put(fetchOrganizationTitle.success(organization));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(fetchOrganizationTitle.failure(error));
  }
}

function* watchFetchOrganizationTitle() {
  yield takeLatest(fetchOrganizationTitle.request, fetchOrganizationTitleAsync);
}

// all
function* watchOrganizations(): SagaGenerator {
  yield all([watchFetchOrganization(), watchUpdateOrganization(), watchFetchOrganizationTitle()]);
}

export default watchOrganizations;
